import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Arrow = ({ dir, onClick, testid }) => {
  const Icon = dir === "prev" ? ChevronLeft : ChevronRight;
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      aria-label={dir === "prev" ? "Foto anterior" : "Próxima foto"}
      className={`absolute top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-[#faf7f2]/90 text-[#163323] shadow-lg backdrop-blur transition-[transform,background-color] duration-300 hover:scale-110 hover:bg-white sm:h-14 sm:w-14 ${
        dir === "prev" ? "left-3 sm:left-5" : "right-3 sm:right-5"
      }`}
    >
      <Icon className="h-6 w-6" />
    </button>
  );
};

export default function Gallery({ images, name, testid }) {
  const [idx, setIdx] = useState(0);
  const go = (d) => setIdx((i) => (i + d + images.length) % images.length);

  return (
    <div data-testid={testid} className="min-w-0">
      <div className="relative aspect-[4/3] overflow-hidden rounded-sm bg-[#163323] lg:aspect-[16/11]">
        <AnimatePresence initial={false}>
          <motion.img
            key={idx}
            src={images[idx]}
            alt={`${name} - foto ${idx + 1}`}
            className="absolute inset-0 h-full w-full cursor-grab object-cover active:cursor-grabbing"
            initial={{ opacity: 0, scale: 1.06 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.2}
            onDragEnd={(_, info) => {
              if (info.offset.x < -60) go(1);
              else if (info.offset.x > 60) go(-1);
            }}
          />
        </AnimatePresence>
        <Arrow dir="prev" onClick={() => go(-1)} testid={`${testid}-prev-button`} />
        <Arrow dir="next" onClick={() => go(1)} testid={`${testid}-next-button`} />
        <div data-testid={`${testid}-counter`} className="absolute bottom-4 left-4 z-10 rounded-full bg-[#0d2016]/70 px-4 py-1.5 text-xs font-bold tracking-[0.2em] text-[#faf7f2] backdrop-blur">
          {String(idx + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
        </div>
      </div>
      <div className="mt-3 flex gap-2 overflow-x-auto pb-1" data-lenis-prevent>
        {images.map((src, i) => (
          <button
            key={src}
            data-testid={`${testid}-thumb-${i}`}
            onClick={() => setIdx(i)}
            className={`relative h-14 w-20 flex-none overflow-hidden rounded-sm transition-opacity duration-300 sm:h-16 sm:w-24 ${i === idx ? "opacity-100 ring-2 ring-[#c86d4b]" : "opacity-55 hover:opacity-100"}`}
          >
            <img src={src} alt="" className="h-full w-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
}
